<div class="agpr-formField agpr-filterField">
    <label
        *ngIf="field.label"
        id="filterField_filterDropdownLabel"
        class="agpr-formField-label"
    >
        {{ field.label | localize }}
    </label>
    <agpr-filter-dropdown
        id="filterField"
        [ngClass]="{ 'agpr-filterField-filter' : hasFilterChips }"
        [showQuickFilter]="true"
        [quickFilterPlaceholder]="field.quickSearchPlaceholder"
        ariaLabelledBy="filterField_filterDropdownLabel"
    >
    </agpr-filter-dropdown>
    <div
        *ngIf="hasFilterChips"
        class="agpr-filterField-filterChips"
    >
        <agpr-filter-chips
            id="filterField">
        </agpr-filter-chips>
    </div>
</div>
